import { CORRELATION_ID_KEY } from "../constants/common"
import { INCO2Address } from "../types"

export const parseGooglePlace = (place: { geometry?: any; formatted_address?: any; address_components?: any }) => {
  const { address_components, formatted_address: formattedAddress } = place

  const { short_name: provinceCode, long_name: provinceDescr } =
    address_components.find((a: { types: string | string[] }) => a.types.includes("administrative_area_level_2")) || {}

  const street_number = address_components.find((a: { types: string | string[] }) => a.types.includes("street_number"))?.long_name
  let route = address_components.find((a: { types: string | string[] }) => a.types.includes("route"))?.long_name
  if (!route && address_components.length > 0) route = address_components[0]?.long_name

  const addressInfo: INCO2Address = {
    latitude: place.geometry?.location?.lat(),
    longitude: place.geometry?.location?.lng(),
    street: street_number ? `${route}, ${street_number}` : route,
    postalCode: address_components.find((a: { types: string | string[] }) => a.types.includes("postal_code"))?.long_name,
    //city: address_components.find((a: { types: string | string[] }) => a.types.includes("administrative_area_level_3"))?.long_name,
    city: extractCity(address_components),
    provinceCode,
    provinceDescr,
    countryCode: address_components.find((a: { types: string | string[] }) => a.types.includes("country"))?.short_name,
    formattedAddress,
  }
  return addressInfo
}

const extractCity = (address_components: any) => {
  let area = address_components.find((a: { types: string | string[] }) => a.types.includes("administrative_area_level_3"))?.long_name
  console.log("administrative_area_level_3", area)

  let locality = address_components.find((a: { types: string | string[] }) => a.types.includes("locality"))?.long_name
  console.log("locality", locality)

  return area ?? locality ?? "N/A"
}

export const getCorrelation = () => sessionStorage.getItem(CORRELATION_ID_KEY) ?? "UNKNOWN"
